import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
	selector: 'kwo-content-blocked',
	templateUrl: './content-blocked.component.html',
	styleUrls: ['./content-blocked.component.scss'],
	host: { 'class': '' },
	standalone: true,
	imports: [CommonModule, FaIconComponent, MatDialogModule, TranslateModule],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockedComponent implements OnInit {

	constructor(public dialogRef: MatDialogRef<ContentBlockedComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private router: Router) { }

	ngOnInit(): void {

	}

	navigateSubscribe() {

		this.router.navigate(['/aanmelden']);
	}

	goToLogin() {

		this.dialogRef.close();
		this.router.navigate(['/inloggen']);
	}
}